/**
 * Delivery-mode buckets for the "How would you like to meet?" step.
 *
 * A channel's services sort into three buckets by service_delivery_mode:
 *   virtual   → fully_virtual (video visit)
 *   phone     → phone_consultation (the provider calls the patient)
 *   in_person → everything else
 * Inquiry tiles (online_booking_option === 'inquiry') WITHOUT a
 * service_delivery_mode belong to every bucket and never create an option on
 * their own. An inquiry tile that does carry a mode is that mode's service and
 * does create the option — selecting it routes to the inquiry end screen, which
 * is how "in person = plain enquiry, phone = scheduler" is configured.
 */
export const DELIVERY_MODES = ['in_person', 'virtual', 'phone'];

export function procedureDeliveryBucket(procedure) {
    if (procedure?.service_delivery_mode === 'fully_virtual') return 'virtual';
    if (procedure?.service_delivery_mode === 'phone_consultation') return 'phone';
    return 'in_person';
}

/**
 * True when the booking is performed remotely (every service is a video or
 * phone visit) — the location address must not be shown for it.
 */
export function isRemoteBooking(procedures) {
    return (procedures?.length ?? 0) > 0
        && procedures.every((p) => ['fully_virtual', 'phone_consultation'].includes(p?.service_delivery_mode));
}

/** True when every service is a phone consultation. */
export function isPhoneBooking(procedures) {
    return (procedures?.length ?? 0) > 0
        && procedures.every((p) => p?.service_delivery_mode === 'phone_consultation');
}
